import { action } from 'typesafe-actions';
// Fetch all application features
export const FETCH_APPLICATION_FEATURES_REQUEST = '[Request] Fetch application features';
export const FETCH_APPLICATION_FEATURES_SUCCESS = '[Success] Fetch application features';
export const FETCH_APPLICATION_FEATURES_FAILURE = '[Failure] Fetch application features';
export const fetchApplicationFeaturesRequest = (apps) => action(FETCH_APPLICATION_FEATURES_REQUEST, { apps });
export const fetchApplicationFeaturesSuccess = (apps, features) => action(FETCH_APPLICATION_FEATURES_SUCCESS, {
    apps,
    features
});
export const fetchApplicationFeaturesFailure = (apps, error) => action(FETCH_APPLICATION_FEATURES_FAILURE, { apps, error });
//# sourceMappingURL=actions.js.map